import { render, staticRenderFns } from "./list-app.vue?vue&type=template&id=7dc94d8d&scoped=true"
import script from "./list-app.vue?vue&type=script&lang=js"
export * from "./list-app.vue?vue&type=script&lang=js"
import style0 from "./list-app.vue?vue&type=style&index=0&id=7dc94d8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc94d8d",
  null
  
)

export default component.exports